import type { UnderSaturatedOilViscosityParameters } from "../../d";

export function underSaturatedOilViscosityCalculator(
  params: UnderSaturatedOilViscosityParameters
): {
  undersaturatedOilViscosity: number;
  undersaturatedOilViscosity_gt_31: number;
  undersaturatedOilViscosity_22_31: number;
  undersaturatedOilViscosity_10_22: number;
  undersaturatedOilViscosity_lt_10: number;
} {
  const {
    inSituPressurePSIA,
    saturatedOilViscosity,
    bubblePointPressurePSIA,
    deadOilViscosity,
    oilAPI
  } = params;

  // Q80: =Q20-((1-(D3/J18))*((10**-1.9*Q17**0.7423*J18**0.5026)/(10**(0.0243*D7))))
  const undersaturatedOilViscosity_gt_31 =
    saturatedOilViscosity -
    (1 - inSituPressurePSIA / bubblePointPressurePSIA) *
      ((10 ** -1.9 *
        deadOilViscosity ** 0.7423 *
        bubblePointPressurePSIA ** 0.5026) /
        10 ** (0.0243 * oilAPI));
  // Q82: =Q20-((1-(D3/J18))*((10**-3.8055*Q17**1.4131*J18**0.6957)/(10**(-0.00288*D7))))
  const undersaturatedOilViscosity_22_31 =
    saturatedOilViscosity -
    (1 - inSituPressurePSIA / bubblePointPressurePSIA) *
      ((10 ** -3.8055 *
        deadOilViscosity ** 1.4131 *
        bubblePointPressurePSIA ** 0.6957) /
        10 ** (-0.00288 * oilAPI));
  // Q84: =0.9886*Q20+0.002763*(D3-J18)*(-0.01153*Q20**1.7933+0.0316*Q20**1.5939)
  const undersaturatedOilViscosity_10_22 =
    0.9886 * saturatedOilViscosity +
    0.002763 *
      (inSituPressurePSIA - bubblePointPressurePSIA) *
      (-0.01153 * saturatedOilViscosity ** 1.7933 +
        0.0316 * saturatedOilViscosity ** 1.5939);
  // Q86: =Q20-((1-(D3/J18))*((10**-2.19*Q17**1.055*J18**0.3132)/(10**(0.0099*D7))))
  const undersaturatedOilViscosity_lt_10 =
    saturatedOilViscosity -
    (1 - inSituPressurePSIA / bubblePointPressurePSIA) *
      ((10 ** -2.19 *
        deadOilViscosity ** 1.055 *
        bubblePointPressurePSIA ** 0.3132) /
        10 ** (0.0099 * oilAPI));

  let undersaturatedOilViscosity = 0;
  if (oilAPI > 31.1) {
    undersaturatedOilViscosity = undersaturatedOilViscosity_gt_31;
  } else if (oilAPI > 22.3 && oilAPI <= 31.1) {
    undersaturatedOilViscosity = undersaturatedOilViscosity_22_31;
  } else if (oilAPI > 10 && oilAPI <= 22.3) {
    undersaturatedOilViscosity = undersaturatedOilViscosity_10_22;
  } else if (oilAPI <= 10) {
    undersaturatedOilViscosity = undersaturatedOilViscosity_lt_10;
  }

  return {
    undersaturatedOilViscosity,
    undersaturatedOilViscosity_gt_31,
    undersaturatedOilViscosity_22_31,
    undersaturatedOilViscosity_10_22,
    undersaturatedOilViscosity_lt_10
  };
}
